import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { createGlobalStyle } from 'styled-components';

import IntlPhone from 'app/components/intlPhone';

import { useAppContext } from '../../hooks';

const IntlPhoneStyles = createGlobalStyle`
  .iti {
    display: block;
  }
`;

function PhoneFormField({ name, label, hint, required = true }) {
  const { config } = useAppContext();
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext();
  const error = errors[name];
  const isTouched = touched[name];
  const showError = !!error && isTouched;
  const defaultValue = values[name];

  const phoneRef = useRef();

  // Update number/country imperatively when values change
  useEffect(() => {
    const instance = phoneRef.current?._inputRef?.current?.getInstance();
    if (!instance) return;

    if (values.country) {
      instance.setCountry(values.country.toUpperCase());
    }
    if (defaultValue) {
      instance.setNumber(defaultValue);
    }
  }, [defaultValue, values.country]);
  return (
    <div>
      <IntlPhoneStyles />
      <div style={{ marginBottom: '1rem' }}>
        <IntlPhone
          ref={phoneRef}
          fieldId={name}
          label={required ? `${label} *` : label}
          hint={hint}
          defaultValue={defaultValue}
          defaultCountry={values.country.toLowerCase() ?? config.language_code}
          setValidPhone={() => false}
          setPhoneNumber={(value) => {
            // only set field if value has changed (this callback fires too often causing problems in validation state)
            if (value !== defaultValue) {
              setFieldValue(name, value);
              if (isTouched) {
                setFieldTouched(name, false, false);
              }
            }
          }}
          onBlur={() => setFieldTouched(name, true, false)}
          error={showError && error}
        />
      </div>
    </div>
  );
}

PhoneFormField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  required: PropTypes.bool,
};

export default PhoneFormField;
